var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.item.external ? "a" : "router-link",
    {
      tag: "component",
      staticClass: "layout-sidebar-item",
      attrs: {
        href: _vm.item.external ? _vm.item.path : null,
        to: _vm.item.external ? null : _vm.item.path,
        target: _vm.item.external ? "_blank" : null
      }
    },
    [
      _c("k-icon", {
        staticClass: "icon",
        attrs: { size: "15", icon: _vm.item.icon }
      }),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.item.name))]),
      _vm._v(" "),
      _vm.arrow
        ? _c("k-icon", {
            staticClass: "arrow",
            attrs: { size: "10", icon: "arrow-right" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d023370", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d023370","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/LayoutSidebarItem.vue
// module id = 2134
// module chunks = 1610